import { useSyncExternalStore } from "react";

import { authStore } from "@/features/auth/store/authStore";

const subscribe = (listener: () => void) => authStore.subscribe(listener);
const getSnapshot = () => authStore.getSnapshot();
const login: typeof authStore.login = (credentials) => authStore.login(credentials);
const logout: typeof authStore.logout = () => authStore.logout();
const initialize: typeof authStore.initialize = () => authStore.initialize();

/**
 * Reactive access to the global auth store. Backed by a module-level singleton (not React context)
 * so that it can also be read/awaited imperatively from TanStack Router's `beforeLoad` hooks via
 * `router context.auth`.
 */
export const useAuth = () => {
  const snapshot = useSyncExternalStore(subscribe, getSnapshot);

  return {
    ...snapshot,
    isAuthenticated: snapshot.status === "authenticated",
    login,
    logout,
    initialize,
  };
};

export type UseAuthReturn = ReturnType<typeof useAuth>;
